(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5494],{

/***/ 96540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
exports.Z = _default;

/***/ }),

/***/ 94895:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 13H5v-2h14v2z"
}), 'Remove');
exports.Z = _default;

/***/ }),

/***/ 81666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69417);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(28482);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _DatePicker_BCCDatePicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28631);
/* harmony import */ var _PersonInput_PersonInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81001);
/* harmony import */ var _HotelSearchAutocomplete_HotelSearchAutocomplete__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8496);
/* harmony import */ var _mui_icons_material_Hotel__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(9001);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(88854);
/* harmony import */ var _HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74231);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(72276);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(50594);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22550);
/* harmony import */ var _utils_store_features_hotelDestinationSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7834);
/* harmony import */ var _utils_store_features_hotelAutocompleteCacheSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48059);
/* harmony import */ var _utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69392);
/* harmony import */ var _utils_userSearchStorage__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85564);

























var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#7E183D"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var HotelSearch = function(param) {
    var viewMode = param.viewMode, value = param.value, collapsed = param.collapsed, toggleSearch = param.toggleSearch, hotelName = param.hotelName, hotelId = param.hotelId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var userStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.user) === null || ref === void 0 ? void 0 : ref.value;
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var hotelAutocompleteCacheStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.hotelAutocompleteCache) === null || ref === void 0 ? void 0 : ref.value;
    });
    var hotelSearchStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.hotelSearch;
    });
    var hotelAutocompleteStore = hotelSearchStore === null || hotelSearchStore === void 0 ? void 0 : hotelSearchStore.autocomplete;
    var hotelDateRangeStore = hotelSearchStore === null || hotelSearchStore === void 0 ? void 0 : hotelSearchStore.dateRange;
    var hotelVisitorsStore = hotelSearchStore === null || hotelSearchStore === void 0 ? void 0 : hotelSearchStore.visitors;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().shape({
        autocomplete: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().nullable().required("Please select destination"),
        dateRange: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().shape({
            departure: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_)().nullable(),
            return: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_)().nullable()
        })
    })), searchSchema = ref[0], setSearchSchema = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        autocomplete: hotelAutocompleteStore,
        dateRange: {
            departure: (hotelDateRangeStore === null || hotelDateRangeStore === void 0 ? void 0 : hotelDateRangeStore.departure) || null,
            return: (hotelDateRangeStore === null || hotelDateRangeStore === void 0 ? void 0 : hotelDateRangeStore.return) || null
        },
        visitors: hotelVisitorsStore || null
    }), initialValues = ref1[0], setInitialValues = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInitialValues({
            autocomplete: hotelAutocompleteStore || initialValues.autocomplete,
            dateRange: {
                departure: (hotelDateRangeStore === null || hotelDateRangeStore === void 0 ? void 0 : hotelDateRangeStore.departure) || initialValues.dateRange.departure,
                return: (hotelDateRangeStore === null || hotelDateRangeStore === void 0 ? void 0 : hotelDateRangeStore.return) || initialValues.dateRange.return
            },
            visitors: hotelVisitorsStore || initialValues.visitors
        });
    }, [
        value,
        hotelDateRangeStore,
        hotelVisitorsStore,
        hotelAutocompleteStore
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (value) {
            var ref;
            if ((ref = value.visitors) === null || ref === void 0 ? void 0 : ref.length) {
                value.visitors.forEach(function(visitor) {
                    if (!visitor.childrenAges) {
                        visitor.childrenAges = [];
                    }
                });
            }
            if (!hotelVisitorsStore || hotelVisitorsStore.length === 0) {
                dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setHotelVisitors */ ._N)(value.visitors || [
                    {
                        adults: 1,
                        childrenAges: []
                    }
                ]));
            }
        }
    }, [
        value
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (hotelName) {
            if (!hotelAutocompleteCacheStore[hotelName]) {
                (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_15__/* .httpGet */ .kA)("/api/hotel/autocomplete?search=".concat(hotelName)).then(function(response) {
                    response.json().then(function(result) {
                        if ((result === null || result === void 0 ? void 0 : result.length) && result.find(function(hotel) {
                            return hotel.n === hotelName;
                        })) {
                            setInitialValues((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, initialValues), {
                                autocomplete: result.find(function(hotel) {
                                    return hotel.n === hotelName && hotel.k === hotelId;
                                })
                            }));
                            dispatch((0,_utils_store_features_hotelAutocompleteCacheSlice__WEBPACK_IMPORTED_MODULE_12__/* .setAutocompleteCache */ .t9)({
                                key: hotelName,
                                value: result
                            }));
                        } else {
                            var autocomplete = {
                                n: hotelName,
                                t: "hotels",
                                s: 1,
                                empty: true
                            };
                            setInitialValues((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, initialValues), {
                                autocomplete: autocomplete
                            }));
                            dispatch((0,_utils_store_features_hotelAutocompleteCacheSlice__WEBPACK_IMPORTED_MODULE_12__/* .setAutocompleteCache */ .t9)({
                                key: hotelName,
                                value: [
                                    autocomplete
                                ]
                            }));
                        }
                    });
                });
            }
        }
    }, [
        hotelName
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.autocomplete) {
            dispatch((0,_utils_store_features_hotelDestinationSlice__WEBPACK_IMPORTED_MODULE_11__/* .setHotelDestination */ .Ub)(initialValues.autocomplete));
        }
    }, [
        initialValues
    ]);
    // Initialize Redux store with date range if it's empty and component has values
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        if ((value === null || value === void 0 ? void 0 : (ref = value.dateRange) === null || ref === void 0 ? void 0 : ref.departure) || (value === null || value === void 0 ? void 0 : (ref1 = value.dateRange) === null || ref1 === void 0 ? void 0 : ref1.return)) {
            if (!(hotelDateRangeStore === null || hotelDateRangeStore === void 0 ? void 0 : hotelDateRangeStore.departure) && !(hotelDateRangeStore === null || hotelDateRangeStore === void 0 ? void 0 : hotelDateRangeStore.return)) {
                dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setHotelDateRange */ .lZ)({
                    departure: value.dateRange.departure,
                    return: value.dateRange.return
                }));
            }
        }
    }, []);
    // Initialize Redux store with visitors if it's empty and component has values
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (value === null || value === void 0 ? void 0 : (ref = value.visitors) === null || ref === void 0 ? void 0 : ref.length) {
            if (!hotelVisitorsStore || hotelVisitorsStore.length === 0) {
                dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setHotelVisitors */ ._N)(value.visitors));
            }
        }
    }, []);
    // Initialize Redux store with visitors if it's empty and component has values
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (value === null || value === void 0 ? void 0 : value.autocomplete) {
            if (!hotelAutocompleteStore) {
                dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setAutocomplete */ .p$)(value.autocomplete));
            }
        }
    }, []);
    var toggleCollapsedSearch = function(event) {
        event.preventDefault();
        toggleSearch();
    };
    var onSubmit = function(values) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        dispatch((0,_utils_store_features_hotelDestinationSlice__WEBPACK_IMPORTED_MODULE_11__/* .setHotelDestination */ .Ub)(values.autocomplete));
        var destination = values.autocomplete ? values.autocomplete.t === "cities" || values.autocomplete.t === "countries" ? values.autocomplete.n : (ref = values.autocomplete) === null || ref === void 0 ? void 0 : (ref1 = ref.p) === null || ref1 === void 0 ? void 0 : ref1[0] : "directly from hotel page";
        var guestsCount = {
            numGuests: 0,
            numAdults: 0,
            numChildren: 0
        };
        values.visitors.forEach(function(v) {
            var ref, ref1;
            var guests = +v.adults + (((ref = v.childrenAges) === null || ref === void 0 ? void 0 : ref.length) || 0);
            guestsCount.numGuests += guests;
            guestsCount.numAdults += +v.adults;
            guestsCount.numChildren += ((ref1 = v.childrenAges) === null || ref1 === void 0 ? void 0 : ref1.length) || 0;
        });
        var tagManagerArgs = {
            dataLayer: {
                event: "hotelSearch",
                destinationCountry: ((ref2 = values.autocomplete) === null || ref2 === void 0 ? void 0 : ref2.cc) || "directly from hotel page",
                destinationCity: destination,
                numGuests: values.visitors.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                    var ref, ref1;
                    acc += ((ref = v.childrenAges) === null || ref === void 0 ? void 0 : ref.length) > 0 ? +v.adults + ((ref1 = v.childrenAges) === null || ref1 === void 0 ? void 0 : ref1.length) : +v.adults;
                    return acc;
                }, 0),
                numAdults: values.visitors.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                    acc += +v.adults;
                    return acc;
                }, 0),
                numChildren: values.visitors.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, v = arguments.length > 1 ? arguments[1] : void 0;
                    var ref;
                    acc += (ref = v.childrenAges) === null || ref === void 0 ? void 0 : ref.length;
                    return acc;
                }, 0),
                userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                pageType: router === null || router === void 0 ? void 0 : router.pathname,
                loginStatus: userStore.userid ? "logged in" : "not logged in",
                membershipId: userStore === null || userStore === void 0 ? void 0 : userStore.membershipNumber,
                traffic_type: (userStore === null || userStore === void 0 ? void 0 : userStore.is_admin) ? "internal" : "external"
            }
        };
        react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default().dataLayer(tagManagerArgs);
        (0,_utils_userSearchStorage__WEBPACK_IMPORTED_MODULE_18__/* .saveHotelSearch */ .Go)({
            destination: destination,
            destinationCountry: (ref3 = values.autocomplete) === null || ref3 === void 0 ? void 0 : ref3.cc,
            guestsCount: guestsCount,
            departure: (ref4 = values.dateRange) === null || ref4 === void 0 ? void 0 : ref4.departure,
            return: (ref5 = values.dateRange) === null || ref5 === void 0 ? void 0 : ref5.return,
            rooms: values.visitors.length
        });
        if (((ref6 = values.autocomplete) === null || ref6 === void 0 ? void 0 : ref6.t) === "hotels" || hotelId) {
            if (router.route === "/hotel/review/[id]" && hotelId) {
                router.push(decodeURI("/hotel/review/".concat(hotelId, "?").concat(qs__WEBPACK_IMPORTED_MODULE_10___default().stringify(values))));
            } else {
                var ref7;
                router.push(decodeURI("/hotel/review/".concat((ref7 = values.autocomplete) === null || ref7 === void 0 ? void 0 : ref7.k.replace("khotel:", "hc-"), "?").concat(qs__WEBPACK_IMPORTED_MODULE_10___default().stringify(values))));
            }
        } else {
            values.search = 1;
            router.push(decodeURI("/hotelsearch?".concat(qs__WEBPACK_IMPORTED_MODULE_10___default().stringify(values))));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        theme: theme,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:w-full",
                children: collapsed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-4 text-center pt-7 font-garamond relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        color: "inherit",
                        onClick: toggleCollapsedSearch,
                        "aria-label": "close",
                        className: "absolute top-0 right-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().hotelSearchContainer)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_23__/* .Formik */ .J9, {
                    enableReinitialize: true,
                    validationSchema: searchSchema,
                    validate: function(values) {
                        var schemaShape = {};
                        if (values.dateRange.departure || values.dateRange.return || hotelId) {
                            // Search hotel offers (or offers for current hotel)
                            schemaShape.dateRange = (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().shape({
                                departure: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_)().nullable().required("Please select Check-in date"),
                                return: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_)().nullable().required("Please select Check-out date")
                            });
                        } else {
                            // Search just hotels without offers (search without dates)
                            schemaShape.dateRange = (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().shape({
                                departure: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_)().nullable(),
                                return: (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_)().nullable()
                            });
                        }
                        if (!hotelId) {
                            // We don't need autocomplete if already in hotel
                            schemaShape.autocomplete = (0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().nullable().required("Please select destination");
                        }
                        setSearchSchema((0,yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry)().shape(schemaShape));
                    },
                    initialValues: initialValues,
                    onSubmit: onSubmit,
                    children: function(param) {
                        var setFieldValue = param.setFieldValue, values = param.values, errors = param.errors, touched = param.touched;
                        var _obj;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_23__/* .Form */ .l0, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, (_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().formContainer), viewMode === "mainSearch"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(_obj, (_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().formContainerSide), viewMode === "sideSearch"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().hotelPersonInput)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().hotelPersonInputWrapper)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PersonInput_PersonInput__WEBPACK_IMPORTED_MODULE_5__/* .PersonInput */ .G, {
                                                name: "visitors",
                                                setFieldValue: function(name, value) {
                                                    setFieldValue(name, value);
                                                    // Sync visitors with Redux store
                                                    if (name === "visitors") {
                                                        dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setHotelVisitors */ ._N)(value));
                                                    }
                                                },
                                                disablePortal: false,
                                                multiple: true,
                                                multipleValue: values === null || values === void 0 ? void 0 : values.visitors,
                                                multiModeHeading: "Room",
                                                primaryColor: "#7E183D"
                                            })
                                        })
                                    }),
                                    !hotelId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().hotelAutocomplete)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HotelSearchAutocomplete_HotelSearchAutocomplete__WEBPACK_IMPORTED_MODULE_6__/* .HotelSearchAutocomplete */ .n, {
                                                setFieldValue: function(name, value) {
                                                    setFieldValue(name, value);
                                                    // Sync autocomplete with Redux store
                                                    if (name === "autocomplete") {
                                                        dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setAutocomplete */ .p$)(value));
                                                    }
                                                },
                                                name: "autocomplete",
                                                label: "Hotel",
                                                placeholder: "Enter destination or hotel name",
                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Hotel__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {}),
                                                error: !!(touched.autocomplete && errors.autocomplete),
                                                primaryColor: "#7E183D",
                                                value: values.autocomplete
                                            }),
                                            touched.autocomplete && errors.autocomplete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().errorMessage),
                                                children: errors.autocomplete
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().hotelDatePicker), "mb-3"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DatePicker_BCCDatePicker__WEBPACK_IMPORTED_MODULE_4__/* .BCCDatePicker */ .l, {
                                            mode: "range",
                                            labelStart: "Check-in",
                                            labelEnd: "Check-out",
                                            setFieldValue: function(name, value) {
                                                setFieldValue(name, value);
                                                // Sync date range with Redux store
                                                if (name === "dateRange") {
                                                    dispatch((0,_utils_store_features_hotelSearchSlice__WEBPACK_IMPORTED_MODULE_13__/* .setHotelDateRange */ .lZ)(value));
                                                }
                                            },
                                            name: "dateRange",
                                            allowSameDateSelection: false,
                                            primaryColor: "#7E183D",
                                            maxRange: 30,
                                            viewMode: viewMode === "sideSearch" ? "vertical" : "horizontal",
                                            rangeValue: [
                                                values.dateRange.departure,
                                                values.dateRange.return, 
                                            ],
                                            error: !!(touched && touched.dateRange && errors.dateRange),
                                            errorMessages: touched && touched.dateRange && errors && errors.dateRange
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()((_HotelSearch_module_scss__WEBPACK_IMPORTED_MODULE_22___default().submit)),
                                        children: [
                                            viewMode === "mainSearch" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                fullWidth: true,
                                                color: "primary",
                                                variant: "contained",
                                                type: "submit",
                                                sx: {
                                                    color: "#ffffff",
                                                    background: "#7E183D",
                                                    textTransform: "unset",
                                                    fontSize: "15px",
                                                    lineHeight: "24px"
                                                },
                                                children: "Search"
                                            }),
                                            viewMode !== "mainSearch" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                fullWidth: true,
                                                color: "dark",
                                                variant: "contained",
                                                type: "submit",
                                                sx: {
                                                    color: "#ffffff",
                                                    background: "#7E183D",
                                                    textTransform: "unset",
                                                    fontSize: "15px",
                                                    lineHeight: "24px"
                                                },
                                                children: "Search"
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HotelSearch);


/***/ }),

/***/ 85564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$W": function() { return /* binding */ getRecentFlightSearches; },
/* harmony export */   "Go": function() { return /* binding */ saveHotelSearch; },
/* harmony export */   "TC": function() { return /* binding */ saveOffer; },
/* harmony export */   "cz": function() { return /* binding */ updateRecentItemTime; },
/* harmony export */   "h1": function() { return /* binding */ removeRecentItem; },
/* harmony export */   "o1": function() { return /* binding */ saveFlightSearch; },
/* harmony export */   "qF": function() { return /* binding */ clearAll; }
/* harmony export */ });
/* unused harmony exports getLastFlightSearch, removeFlightSearch, getLastHotelSearch, getRecentHotelSearches, clearSearches, getLastOffer, getRecentOffers */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52875);


var LOCAL_KEY = "BC_searchHistory";
var EXPIRATION_MONTHS = 2;
function isBrowser() {
    return  true && typeof localStorage !== "undefined";
}
function getStorage() {
    if (!isBrowser()) return {
        flights: defaultSearchData(),
        hotels: defaultSearchData()
    };
    var raw = localStorage.getItem(LOCAL_KEY);
    var data;
    try {
        data = raw ? JSON.parse(raw) : {};
    } catch (e) {
        data = {};
    }
    data.flights = cleanExpired(data.flights || defaultSearchData());
    data.hotels = cleanExpired(data.hotels || defaultSearchData());
    data.offers = cleanExpired(data.offers || defaultSearchData());
    return data;
}
function defaultSearchData() {
    return {
        lastSearch: null,
        searches: []
    };
}
function saveStorage(data) {
    if (!isBrowser()) return;
    data.flights = cleanExpired(data.flights);
    data.hotels = cleanExpired(data.hotels);
    data.offers = cleanExpired(data.offers);
    localStorage.setItem(LOCAL_KEY, JSON.stringify(data));
}
function cleanExpired(section) {
    var now = new Date();
    var cleanedSearches = (section.searches || []).filter(function(s) {
        return s.expiresAt && new Date(s.expiresAt) > now;
    });
    var cleanedLast = section.lastSearch && section.lastSearch.expiresAt && new Date(section.lastSearch.expiresAt) > now ? section.lastSearch : null;
    return {
        lastSearch: cleanedLast,
        searches: cleanedSearches
    };
}
function getExpiryDate(referenceDate) {
    var base = new Date(referenceDate);
    base.setMonth(base.getMonth() + EXPIRATION_MONTHS);
    var now = new Date();
    return base < now ? now.toISOString() : base.toISOString();
}
// --- Flights ---
function saveFlightSearch(search) {
    if (!isBrowser()) return;
    var data = getStorage();
    var enriched = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, search), {
        createdAt: new Date().toISOString(),
        expiresAt: getExpiryDate(search.departureDate || new Date())
    });
    var updated = data.flights.searches.filter(function(s) {
        return JSON.stringify(s) !== JSON.stringify(enriched);
    });
    updated.unshift(enriched);
    data.flights.lastSearch = enriched;
    data.flights.searches = updated.slice(0, 8);
    saveStorage(data);
}
function getLastFlightSearch() {
    var data = getStorage();
    return data.flights.lastSearch;
}
function getRecentFlightSearches() {
    var data = getStorage();
    return data.flights.searches;
}
function removeFlightSearch(search) {
    if (!isBrowser()) return;
    var data = getStorage();
    data.flights.searches = data.flights.searches.filter(function(s) {
        return s.createdAt !== search.createdAt;
    });
    saveStorage(data);
}
// --- Hotels ---
function saveHotelSearch(search) {
    if (!isBrowser()) return;
    var data = getStorage();
    var enriched = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, search), {
        createdAt: new Date().toISOString(),
        expiresAt: getExpiryDate(search.departure || new Date())
    });
    var updated = data.hotels.searches.filter(function(s) {
        return JSON.stringify(s) !== JSON.stringify(enriched);
    });
    updated.unshift(enriched);
    data.hotels.lastSearch = enriched;
    data.hotels.searches = updated.slice(0, 5);
    saveStorage(data);
}
function getLastHotelSearch() {
    var data = getStorage();
    return data.hotels.lastSearch;
}
function getRecentHotelSearches() {
    var data = getStorage();
    return data.hotels.searches;
}
function clearSearches() {
    if (!isBrowser()) return;
    localStorage.removeItem(LOCAL_KEY);
}
// --- Offers ---
function saveOffer(search) {
    if (!isBrowser()) return;
    var data = getStorage();
    var enriched = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, search), {
        createdAt: new Date().toISOString(),
        expiresAt: getExpiryDate(search.departureDate || new Date())
    });
    var updated = data.offers.searches.filter(function(s) {
        return JSON.stringify(s) !== JSON.stringify(enriched);
    });
    updated.unshift(enriched);
    data.offers.lastSearch = enriched;
    data.offers.searches = updated.slice(0, 5);
    saveStorage(data);
}
function getLastOffer() {
    var data = getStorage();
    return data.offers.lastSearch;
}
function getRecentOffers() {
    var data = getStorage();
    return data.offers.searches;
}
function removeRecentItem(search, searchKey) {
    var data = getStorage();
    data[searchKey].searches = data[searchKey].searches.filter(function(s) {
        return s.createdAt !== search.createdAt;
    });
    saveStorage(data);
    return data;
}
// Put search on the first place
function updateRecentItemTime(search, searchKey) {
    var data = getStorage();
    data[searchKey].searches = data[searchKey].searches.map(function(s) {
        return s.createdAt === search.createdAt ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, s), {
            createdAt: new Date().toISOString()
        }) // or any new timestamp
         : s;
    }).sort(function(a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
    });
    saveStorage(data);
    return data;
}
function clearAll(searchKey) {
    var data = getStorage();
    data[searchKey].searches = [];
    saveStorage(data);
    return data;
}


/***/ }),

/***/ 88854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hotelSearchContainer":"HotelSearch_hotelSearchContainer__v3JgU","hotelSearchResultsContainer":"HotelSearch_hotelSearchResultsContainer__EJJTP","loader":"HotelSearch_loader__54cOu","pulseScaleOut":"HotelSearch_pulseScaleOut__QLqcc","listItemContainer":"HotelSearch_listItemContainer__OPmkQ","ratingBadgeCircle":"HotelSearch_ratingBadgeCircle__sGcsx","listItemCarousel":"HotelSearch_listItemCarousel__zj0MJ","ratingBadge":"HotelSearch_ratingBadge__WUSHC","ratingBadgeWrapper":"HotelSearch_ratingBadgeWrapper__yjNRj","ratingBadgeWrapperText":"HotelSearch_ratingBadgeWrapperText___nTLG","listItemContent":"HotelSearch_listItemContent__Lv8jC","listItemContentContainer":"HotelSearch_listItemContentContainer__jrc9C","listItemContentTitle":"HotelSearch_listItemContentTitle__xl3pM","listItemContentDistrict":"HotelSearch_listItemContentDistrict__3pwwv","starRating":"HotelSearch_starRating__tUY_O","listItemContentRating":"HotelSearch_listItemContentRating___KyXs","listItemAbout":"HotelSearch_listItemAbout__dpF0c","viewOnMap":"HotelSearch_viewOnMap__0S4Q_","listItemContentLocation":"HotelSearch_listItemContentLocation__IP2Gf","listItemContentPrice":"HotelSearch_listItemContentPrice__KhC4u","listItemContentPriceHint":"HotelSearch_listItemContentPriceHint__45Sju","listItemContentSelect":"HotelSearch_listItemContentSelect__bav5m","formContainerSide":"HotelSearch_formContainerSide__LmtrW","hotelAutocomplete":"HotelSearch_hotelAutocomplete__GtsEp","hotelPersonInput":"HotelSearch_hotelPersonInput__ck57u","hotelDatePicker":"HotelSearch_hotelDatePicker__Ln6LK","submit":"HotelSearch_submit___MqN2","formContainer":"HotelSearch_formContainer__hngmr","hotelPersonInputWrapper":"HotelSearch_hotelPersonInputWrapper__IxQSk","errorMessage":"HotelSearch_errorMessage__G9emK","suggestFlightSearch":"HotelSearch_suggestFlightSearch__9uETC","suggestFlightIconWrapper":"HotelSearch_suggestFlightIconWrapper__oG04z","suggestFlightText":"HotelSearch_suggestFlightText__T4nm2","suggestFlightLink":"HotelSearch_suggestFlightLink__Md3Az"};

/***/ })

}]);